import { ValidationErrorMessages } from '@constants/forms';
import { customerNumberRegEx, partnerNumberRegEx } from '@constants/regEx';
import {
  INTRODUCED_BY,
  ReferralFieldErrors,
  ReferralFieldFormValues,
} from '@src/types/attribution';

const validateReferralField = <T extends ReferralFieldFormValues>(
  values: T
) => {
  const errors: ReferralFieldErrors = {};
  const { introducedBy, customerReferral, connectorReferral, partnerReferral } =
    values;

  if (!introducedBy) {
    errors.introducedBy = ValidationErrorMessages.FIELD_REQUIRED;
  }

  if (introducedBy === INTRODUCED_BY.CUSTOMER) {
    if (!customerReferral) {
      errors.customerReferral = ValidationErrorMessages.FIELD_REQUIRED;
    } else if (!customerNumberRegEx.test(customerReferral)) {
      errors.customerReferral =
        ValidationErrorMessages.INVALID_CUSTOMER_ACCOUNT_NUMBER;
    }
  }

  if (introducedBy === INTRODUCED_BY.CONNECTOR) {
    if (!connectorReferral) {
      errors.connectorReferral = ValidationErrorMessages.FIELD_REQUIRED;
    }
  }

  if (introducedBy === INTRODUCED_BY.PARTNER) {
    if (!partnerReferral) {
      errors.partnerReferral = ValidationErrorMessages.FIELD_REQUIRED;
    } else if (!partnerNumberRegEx.test(partnerReferral)) {
      errors.partnerReferral = ValidationErrorMessages.INVALID_ACCOUNT_NUMBER;
    }
  }

  return errors;
};

export { validateReferralField };
